export default __webpack_public_path__ + "static/media/telefonos_utiles.efd47695.jpg";